import React, { Component } from "react";
import { render } from "react-dom";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { Floorplan } from '@components/icon/icon';

const images = [
  "//placekitten.com/1500/500",
  "//placekitten.com/4000/3000",
  "//placekitten.com/800/1200",
  "//placekitten.com/1500/1500"
];

class FloorplamModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false
    };
  }

  render() {
    const { photoIndex, isOpen } = this.state;
    return (
      <div>
        <a className="floor-plans" href="javascript:;" onClick={() => this.setState({ isOpen: true })}>
        <Floorplan /> <span>Floorplans</span>
        </a>

        {isOpen && (
          <Lightbox  
            enableZoom={false}
            mainSrc={this.props.floorplanimages[photoIndex]}
            nextSrc={this.props.floorplanimages.length > 1 && this.props.floorplanimages[(photoIndex + 1) % this.props.floorplanimages.length]}
            prevSrc={this.props.floorplanimages.length > 1 && this.props.floorplanimages[(photoIndex + this.props.floorplanimages.length - 1) % this.props.floorplanimages.length]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + this.props.floorplanimages.length - 1) % this.props.floorplanimages.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % this.props.floorplanimages.length
              })
            }
          />
        )}
      </div>
    );
  }
}

export default FloorplamModal